import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import WebinarNewForm from './forms/CreateWebinarForm';
import {fetchSites} from '../sites/thunks';
import {createWebinar} from './thunks';

class WebinarCreate extends Component {
    componentWillMount() {
        this.props.fetchSites();
    }

    handleCreateWebinarSubmit(formProps) {
        this.props.createWebinar(formProps);
    }

    render() {
        return (
            this.props.loading !== true && (
                <WebinarNewForm
                    allSites={this.props.allSites}
                    classes={this.props.classes}
                    handleFormSubmit={this.handleCreateWebinarSubmit.bind(this)}
                    touched={this.props.touched}
                    loading={this.props.loading}
                />
            )
        );
    }
}

const mapStateToProps = state => ({
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.webinars.touched,
    allSites: state.sites.all,
});

export default connect(
    mapStateToProps,
    {
        fetchSites,
        createWebinar,
    }
)(withStyles(styles)(WebinarCreate));



// WEBPACK FOOTER //
// ./src/containers/webinars/WebinarCreate.jsx